export const getDefaultState = () => {
  return {
    staffs: null,
    currentPage: null,
    staffChannels: null,
    dashboardDigest: null,
    staffFilter: null, //Same fields from firestore
    sort: null,
    staffRoles: null,
    endStaffResults: null
  }
}

export const state = getDefaultState
